import { render } from "./NotFound.vue?vue&type=template&id=0d4073a0&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=0d4073a0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0d4073a0"

export default script